<app-side-menu (toggle)="toggleCollapse($event)"></app-side-menu>
  <head>
    <link rel="stylesheet" href="faq.component.css" importance="1">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0/css/materialize.min.css">
    <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
  </head>
  
  <body class="green lighten-5">
    <div class="navbar" [class.admin-expanded]="isNavbarExpanded">
      <app-navbar></app-navbar>
    </div>
    <br>
    <br>
    <br>
    <br>

    <div class="blue-grey lighten-5 main-panel" [class.admin-expanded]="isNavbarExpanded">
  
      <div class="row white" style="border-radius: 20px 20px 0 0 ;">
        <div class="col s12">
          <h2>FAQ & Support</h2>
        </div>
      </div>

      <div class="row right-align" style="padding-right: 20px">
        <!-- <a href="https://www.unipetenergy.co/contact/" target=”_blank”><h5 style="color:#E65F53"><u>Get in touch with Unipet Support</u></h5></a> -->
      </div>
      <div class="row" style="padding: 20px; padding-top:0%"><!-- Body -->
        <blockquote>
          <h3 class="subtitle"><b>FREQUENTLY ASKED QUESTIONS</b></h3>
        </blockquote>
        <br>

        <div *ngIf="loading" class="spinner-wrapper">
          <div class="spinner"></div>
        </div>

        <div class="row" *ngFor="let Faq of faqItems let i = index">
            <div class="faq-accordion">
              <div class="card hoverable faq-card" (click)="toggleFaq(i)">
                <div class="faq-header">
                  <h4>{{Faq.strQuestion}}</h4>
                  <span class="accordion-icon" [class.expanded]="Faq.isExpanded">
                    <i class="material-icons">{{Faq.isExpanded ? 'expand_less' : 'expand_more'}}</i>
                  </span>
                </div>
              </div>
              <div class="faq-answer" [class.expanded]="Faq.isExpanded">
                <div class="faq-answer-content">
                  <p>{{Faq.strAnswer}}</p>
                </div>
              </div>
              <button *ngIf="isSuperAdminRole(role)" class="delete-text" (click)="deleteFAQ(Faq.intFaqPK)">
                Delete Question
              </button>
            </div>
        </div>
        <br>
      </div>
      <div class="white" style="padding: 20px">
        <blockquote>
          <h3 class="subtitle"><b>VIDEO GUIDE</b></h3>
        </blockquote>
        
        <!-- Vendor Tutorial Videos -->
        <h4 style="margin-top: 20px; margin-bottom: 15px;"><b>Vendor Tutorials</b></h4>
        <div class="video-row">
          <div class="video-item" (click)="openLightbox('https://www.youtube.com/embed/64Au4ziBK3M?si=m6RPuuFdQm3IdAmz')">
            <h5>Welcome Vendor</h5>
            <div class="thumbnail">
              <img src="https://img.youtube.com/vi/64Au4ziBK3M/0.jpg" alt="Intro to Dashboard">
              <div class="play-button">▶</div>
            </div>
          </div>
        
          <div class="video-item" (click)="openLightbox('https://www.youtube.com/embed/G2r2tcTFyOM?si=WKcebMpmhnMLwV9s')">
            <h5>How to Resubmit</h5>
            <div class="thumbnail">
              <img src="https://img.youtube.com/vi/G2r2tcTFyOM/0.jpg" alt="Intro to Metrics">
              <div class="play-button">▶</div>
            </div>
          </div>
        </div>

        <!-- Admin Tutorial Videos -->
        <div *ngIf="isAdminRole(role)">
          <h4 style="margin-top: 30px; margin-bottom: 15px;"><b>Admin Tutorials</b></h4>
          <div class="video-row">
            <div class="video-item" (click)="openLightbox('https://www.youtube.com/embed/kY8nag2hvIU?si=Lmei2nCNn5WE0PLv')">
              <h5>Welcome Admin</h5>
              <div class="thumbnail">
                <img src="https://img.youtube.com/vi/LP77QtIsJ0g/0.jpg" alt="Managing a Vendor">
                <div class="play-button">▶</div>
              </div>
            </div>

            <div class="video-item" (click)="openLightbox('https://www.youtube.com/embed/RF_0h3DBKOQ?si=cAHrhq40cqPTcWDO')">
              <h5>Managing FAQs</h5>
              <div class="thumbnail">
                <img src="https://img.youtube.com/vi/RF_0h3DBKOQ/0.jpg" alt="Managing FAQs">
                <div class="play-button">▶</div>
              </div>
            </div>

            <div class="video-item" (click)="openLightbox('https://www.youtube.com/embed/LP77QtIsJ0g?si=9RqOJs1xqpfT4S5-')">
              <h5>Managing a Vendor</h5>
              <div class="thumbnail">
                <img src="https://img.youtube.com/vi/LP77QtIsJ0g/0.jpg" alt="Managing a Vendor">
                <div class="play-button">▶</div>
              </div>
            </div>
          </div>

        </div>

        <!-- Lightbox Modal -->
        <div class="lightbox" *ngIf="isLightboxOpen" (click)="closeLightbox()">
          <div class="lightbox-content" (click)="$event.stopPropagation()">
            <span class="lightbox-close" (click)="closeLightbox()">×</span>
            <iframe
              [src]="selectedVideoUrl"
              frameborder="0"
              allowfullscreen
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
            ></iframe>
          </div>
        </div>
        
      </div>
    </div>
  </body>
